import Vue from "vue";
import Router from "vue-router";
import CourseList from "@/components/sites/CourseList";
import Membersettings from "@/components/sites/Membersettings";
import CompanySettings from "@/components/sites/CompanySettings";
import Profile from "@/components/sites/Profile";
import SuperAdminMemberSettings from "@/components/sites/SuperAdminMemberSettings";
import SuperAdminCompanySettings from "@/components/sites/SuperAdminCompanySettings";
import SuperAdminCourseSettings from "@/components/sites/SuperAdminCourseSettings";
import SuperAdminPackageSettings from "@/components/sites/SuperAdminPackageSettings";
import Lizenzverwaltung from "@/components/sites/Lizenzverwaltung";
import Validation from "@/components/sites/Validation";
import Home from "@/components/sites/Home";
import TempLogin from "@/components/sites/TempLogin";
import SuperAdminCertUpload from "@/components/sites/SuperAdminCertUpload.vue";
import SuperAdminCertSearch from "@/components/sites/SuperAdminCertSearch.vue";
import SuperAdminPdfStorageSettings from "@/components/sites/SuperAdminPdfStorageSettings.vue";
import ShippersDeclarationSite from "@/components/sites/ShippersDeclarationSite.vue";
import SuperAdminCsvUpload from "@/components/sites/SuperAdminLiveCourses.vue";
import SuperAdminCourseApplications from "@/components/sites/SuperAdminCourseApplications.vue";
import PublicCourseList from "@/components/sites/PublicCourseList.vue";
import SuperAdminSyncIssues from "@/components/sites/SuperAdminSyncIssues.vue";

Vue.use(Router);

const router = new Router({
    routes: [{
        path: "/", name: "Home", components: {default: Home, header: {}}, meta: {
            title: "Home", breadcrumb: [], isAuthenticated: false
        }
    }, {
        path: "/login", name: "Login", components: {default: TempLogin, header: {}}, meta: {
            title: "Login", breadcrumb: [], isAuthenticated: false
        }
    }, {
        path: "/kurse", name: "CourseList", components: {default: CourseList, header: {}}, meta: {
            title: "Kursliste", breadcrumb: [], isAuthenticated: true
        }
    }, {
        path: "/validation", name: "Validation", components: {default: Validation, header: {}}, meta: {
            title: "Zertifikat Validieren", breadcrumb: [], isAuthenticated: false
        }
    }, {
        path: "/kursliste", name: "PublicCourseList", components: {default: PublicCourseList, header: {}}, meta: {
            title: "Kursliste", breadcrumb: [], isAuthenticated: false
        }
    }, {
        path: "/profil", name: "Profile", components: {default: Profile, header: {}}, meta: {
            title: "Profil", breadcrumb: [], isAuthenticated: true
        }
    }, {
        path: "/einstellungen", name: "CompanySettings", components: {default: CompanySettings, header: {}}, meta: {
            title: "Einstellungen", breadcrumb: [], isAuthenticated: true
        }
    }, {
        path: "/nutzer", name: "MemberSettings", components: {default: Membersettings, header: {}}, meta: {
            title: "Nutzerverwaltung", breadcrumb: [], isAuthenticated: true
        }
    }, {
        path: "/superadmin-nutzer",
        name: "SuperAdminMemberSettings",
        components: {default: SuperAdminMemberSettings, header: {}},
        meta: {
            title: "SuperAdminMemberSettings", breadcrumb: [], isAuthenticated: true
        }
    }, {
        path: "/superadmin-firmen",
        name: "SuperAdminCompanySettings",
        components: {default: SuperAdminCompanySettings, header: {}},
        meta: {
            title: "Firmenverwaltung", breadcrumb: [], isAuthenticated: true
        }
    }, {
        path: "/lizenzen", name: "Lizenzverwaltung", components: {default: Lizenzverwaltung, header: {}}, meta: {
            title: "Lizenzverwaltung", breadcrumb: [], isAuthenticated: true
        }
    }, {
        path: "/shippersdeclaration",
        name: "Shippers Declaration",
        components: {default: ShippersDeclarationSite, header: {}},
        meta: {
            title: "Shippers Declaration", breadcrumb: [], isAuthenticated: true
        }
    }, {
        path: "/superadmin-pakete",
        name: "SuperAdminPackageSettings",
        components: {default: SuperAdminPackageSettings, header: {}},
        meta: {
            title: "Paketverwaltung", breadcrumb: [], isAuthenticated: true
        }
    }, {
        path: "/superadmin-csv",
        name: "SuperAdminCsvUpload",
        components: {default: SuperAdminCsvUpload, header: {}},
        meta: {
            title: "CSV Aupload", breadcrumb: [], isAuthenticated: true
        }
    }, {
        path: "/superadmin-pdfs",
        name: "SuperAdminPdfStorageSettings",
        components: {default: SuperAdminPdfStorageSettings, header: {}},
        meta: {
            title: "PDF Dateien", breadcrumb: [], isAuthenticated: true
        }
    }, {
        path: "/superadmin-certupload",
        name: "SuperadminCertUpload",
        components: {default: SuperAdminCertUpload, header: {}},
        meta: {
            title: "SuperAdminCertUpload", breadcrumb: [], isAuthenticated: true
        }
    }, {
        path: "/superadmin-certSearch",
        name: "SuperadminCertSearch",
        components: {default: SuperAdminCertSearch, header: {}},
        meta: {
            title: "SuperAdminCertSearch", breadcrumb: [], isAuthenticated: true
        }
    }, {
        path: "/superadmin-buycourse",
        name: "SuperAdminCourseApplications",
        components: {default: SuperAdminCourseApplications, header: {}},
        meta: {
            title: "SuperAdminCourseApplications", breadcrumb: [], isAuthenticated: true
        }
    }, {
        path: "/superadmin-sync-issues",
        name: "SuperAdminSyncIssues",
        components: {default: SuperAdminSyncIssues, header: {}},
        meta: {
            title: "Sync-Probleme", breadcrumb: [], isAuthenticated: true
        }
    }, {
        path: "/superadmin-schulungen",
        name: "SuperAdminCourseSettings",
        components: {default: SuperAdminCourseSettings, header: {}},
        meta: {
            title: "Kursverwaltung", breadcrumb: [], isAuthenticated: true
        }
    },]
});


export default router;
